module.exports = __webpack_public_path__ + "img/Villa_Borna_50.a44c71ae.jpg";